# form-field-required = *
form-field-required = {" "}(erforderlich)

form-field-optional = {""}
# form-field-optional = {" "}(optional)

form-field-if-available = {" "}(falls vorhanden)

